<div class="container d-flex align-items-center justify-content-center">
  <div class="row justify-content-center">
    <div class="loan-container col-12 col-md-8 col-lg-6">
      <section class="loan-title">
        <header>
          <h1 class="d-flex justify-content-center copec-bold-20 mt-3 mb-2">
            Responder solicitud
          </h1>
          <p class="copec-rg-16 mt-3 mb-2">
            La solicitud para <span class="copec-bold-16">Préstamo compañía</span> ha sido aprobada exitosamente.
          </p>
        </header>
      </section>

      <section class="loan-box">
        <div class="row">
          <div>
            <table class="table transparent-table">
              <caption></caption>
              <tbody>
                <tr>
                  <th class="copec-bold-14" scope="col">Solicitante</th>
                  <td class="copec-rg-14">{{ nombre_solicitante }}</td>
                </tr>
                <tr>
                  <th class="copec-bold-14" scope="col">Motivo de la solicitud</th>
                  <td class="copec-rg-14">{{ motivo_solicitud }}</td>
                </tr>
                <tr>
                  <th class="copec-bold-14" scope="col">Monto</th>
                  <td class="copec-rg-14">{{ monto_solicitud }}</td>
                </tr>
                <tr>
                  <th class="copec-bold-14" scope="col">Compromiso de pago</th>
                  <td class="copec-rg-14">{{ compromiso_pago_solicitud }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section class="box-input">
        <p class="copec-rg-14">*Antecedentes</p>
        <input
          type="text"
          [(ngModel)]="inputText"
          (input)="updateCharCount()"
          maxlength="200"
          class="input-border-bottom"
        />
        <div class="d-flex justify-content-end mt-2">{{ charCount }}/200</div>
        <p class="error-messages-input" *ngIf="this.emptyFieldForm">
          Debes completar este campo
        </p>
      </section>
      <section class="d-flex justify-content-end box-button">
        <button class="copec-bold-14 button-nocumple" (click)="rechazar()" type="submit">No cumple</button>
        <button class="copec-bold-14 button-cumple" (click)="aprobar()" type="submit">Cumple</button>
      </section>

    </div>
    <section class="d-flex justify-content-center">
      <p class="copec-rg-16 paragraph">Si tienes dudas puedes contactarte con la encargada en Copec Camila Suárez al mail 'camila.suarez&#64;copec.cl'</p>
    </section>
  </div>
</div>

